export default __webpack_public_path__ + "static/media/619.e7f4e567.gif";